import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed, ref } from 'vue';
import { propTypes } from '@/utils/propTypes';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'ImageViewer'
  },
  __name: 'ImageViewer',
  props: {
    urlList: {
      type: Array,
      default: () => []
    },
    zIndex: propTypes.number.def(200),
    initialIndex: propTypes.number.def(0),
    infinite: propTypes.bool.def(true),
    hideOnClickModal: propTypes.bool.def(false),
    teleported: propTypes.bool.def(false),
    show: propTypes.bool.def(false)
  },
  setup(__props) {
    const props = __props;
    const getBindValue = computed(() => {
      const propsData = {
        ...props
      };
      delete propsData.show;
      return propsData;
    });
    const show = ref(props.show);
    const close = () => {
      show.value = false;
    };
    return (_ctx, _cache) => {
      const _component_ElImageViewer = _resolveComponent("ElImageViewer");
      return show.value ? (_openBlock(), _createBlock(_component_ElImageViewer, _mergeProps({
        key: 0
      }, getBindValue.value, {
        onClose: close
      }), null, 16)) : _createCommentVNode("", true);
    };
  }
});